import { useCallback } from "react";

export const useDashboardHistoryHandler = ({
    filters,
    updateFilters,
    fetchSemanticRCA2,
    fetchCategories,
    fetchAllCompanyDetails,
    fetchSpatialData,
    setTotalCounts,
    setIsLoading,
    fethAllCompanies,
    fetchAllStatesData,
    fetchAllAlerts,
    setIsCategoriesLoading,
    setIsAlertsLoading,
    setIsCompaniesLoading,
    setIsStatesLoading,
    fetchAllTypeCompaniesData
}) => {
    const handleDashboardHistoryClick = useCallback(async (historyItem) => {
        setIsLoading(true);
        try {
            const { params } = historyItem;
            console.log(params);
            let categoryData = [];
            updateFilters({
                query: params.query,
                startDate: new Date(params.start_date),
                endDate: new Date(params.end_date),
                threshold: params.threshold,
                value: params.value,
                complaintNumbers: params.complaint_numbers
            });

            const newFilters = {
                ...filters,
                query: params.query,
                startDate: new Date(params.start_date),
                endDate: new Date(params.end_date),
                threshold: params.threshold,
                value: params.value,
                complaintNumbers: params.complaint_numbers
            };

            const data = await fetchSemanticRCA2({
                ...newFilters,
                query: params.query,
                complaintNumbers: params.complaint_numbers,
            });
            categoryData = [
                params.query,
                {
                    prompt: params.prompt,
                    total_counts: params.total_counts,
                    complaintNumbers: params.complaint_numbers
                }
            ];

            setTotalCounts(params?.total_counts || 0);

            // Set granular loading states
            if (setIsCategoriesLoading) setIsCategoriesLoading(true);
            if (setIsStatesLoading) setIsStatesLoading(true);
            if (setIsCompaniesLoading) setIsCompaniesLoading(true);
            if (setIsAlertsLoading) setIsAlertsLoading(true);

            // Execute fetches in parallel
            // const fetchCompaniesPromise = fethAllCompanies(categoryData, params?.complaint_numbers, newFilters)
            //     .finally(() => { if (setIsCompaniesLoading) setIsCompaniesLoading(false); });
            const fetchCompaniesPromise = fetchAllTypeCompaniesData(categoryData, params?.complaint_numbers, newFilters)
                .finally(() => { if (setIsCompaniesLoading) setIsCompaniesLoading(false); });

            const fetchStatesPromise = fetchAllStatesData(categoryData, params?.complaint_numbers, newFilters)
                .finally(() => { if (setIsStatesLoading) setIsStatesLoading(false); });

            const fetchCategoriesAndAlertsPromise = (async () => {
                try {
                    const updatedCategories = await fetchCategories(categoryData, newFilters);
                    if (setIsCategoriesLoading) setIsCategoriesLoading(false);

                    // Handle empty subcategories response
                    if (!updatedCategories || Object.keys(updatedCategories).length === 0) {
                        console.warn('No subcategories found for history item:', params.query);
                        if (setIsAlertsLoading) setIsAlertsLoading(false);
                        return;
                    }

                    await fetchAllAlerts(params?.complaint_numbers, updatedCategories, newFilters);
                } catch (err) {
                    console.error("Error in categories/alerts fetch:", err);
                } finally {
                    if (setIsCategoriesLoading) setIsCategoriesLoading(false);
                    if (setIsAlertsLoading) setIsAlertsLoading(false);
                }
            })();

            await Promise.all([fetchCompaniesPromise, fetchStatesPromise, fetchCategoriesAndAlertsPromise]);
        } catch (error) {
            console.error('Error loading history item:', error);
        } finally {
            setIsLoading(false);
        }
    }, [
        filters,
        updateFilters,
        fetchSemanticRCA2,
        fetchCategories,
        setTotalCounts,
        setIsLoading,
        fetchAllStatesData,
        fethAllCompanies,
        setIsCategoriesLoading,
        setIsAlertsLoading,
        setIsCompaniesLoading,
        setIsStatesLoading
    ]);

    return { handleDashboardHistoryClick };
}